import styled from '@emotion/styled';
import { Stack, tokens } from '@hotjar/hotsauce';
import { SkeletonLoader } from '~/subscription-management/external-dependencies/webapp-utils';

const S = {
  Container: styled.div`
    position: absolute;
    top: ${tokens.spacer.x1};
    left: 0;
    right: 0;
    bottom: 0;
    background: ${tokens.color.white};
  `,
  SkeletonLoaderLabel: styled(SkeletonLoader.Line)`
    width: 25%;
  `,
  SkeletonLoaderField: styled.div`
    width: 100%;
  `,
  FullWidthStack: styled(Stack)`
    width: 100%;
  `,
};

const SkeletonLoaderFieldWithLabel = (): JSX.Element => (
  <S.SkeletonLoaderField>
    <S.SkeletonLoaderLabel />
    <SkeletonLoader.Line size="40px" />
  </S.SkeletonLoaderField>
);

export const CreditCardDetailsLoader = (): JSX.Element => (
  <S.Container>
    <Stack preset="form">
      <SkeletonLoader.Line size="40px" />
      <SkeletonLoaderFieldWithLabel />
      <Stack>
        <SkeletonLoaderFieldWithLabel />
        <S.FullWidthStack>
          <SkeletonLoaderFieldWithLabel />
          <S.SkeletonLoaderField />
        </S.FullWidthStack>
      </Stack>
      <SkeletonLoaderFieldWithLabel />
      <SkeletonLoaderFieldWithLabel />
      <Stack>
        <SkeletonLoaderFieldWithLabel />
        <SkeletonLoaderFieldWithLabel />
      </Stack>
      <Stack>
        <SkeletonLoader.Line size="40px" />
        <S.FullWidthStack>
          <S.SkeletonLoaderField />
          <SkeletonLoader.Line size="40px" />
        </S.FullWidthStack>
      </Stack>
    </Stack>
  </S.Container>
);
